import { Metamodel } from '../base/model';
import { ModelConstants } from '../model-constants';
import { Named } from '../base/named';

@Metamodel.model({
    name: ModelConstants.managedVirtualNetwork,
    display: ['Managed Virtual Networks'],
    reusable: true,
    referable: true
})
export class ManagedVirtualNetwork extends Named {
    public preventDataExfiltration: boolean;
}
